
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../../node_modules/core-js/modules/es.array.concat.js';
import React__default from 'react';
import classNames from '../../../../node_modules/classnames/index.js';
import Tooltip from '../../Tooltip/Tooltip.js';
import Text from '../../Text/Text.js';
import { DropdownListItemStyles } from './styles.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var dropdownItemClasses = function dropdownItemClasses(value, className) {
  return classNames(_defineProperty(_defineProperty({
    "dropdown-list-item": true
  }, "".concat(value), true), "".concat(className), Boolean(className)));
};
var DropdownListItem = function DropdownListItem(_ref) {
  var index = _ref.index,
    item = _ref.item,
    isSearchable = _ref.isSearchable,
    level = _ref.level,
    textSize = _ref.textSize,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown;
  var id = item.id,
    _item$isDisabled = item.isDisabled,
    isDisabled = _item$isDisabled === void 0 ? false : _item$isDisabled,
    label = item.label,
    icon = item.icon,
    value = item.value,
    tooltipContent = item.tooltipContent,
    className = item.className;
  var handleOnClickListItem = function handleOnClickListItem(e) {
    e.stopPropagation();
    onClick(item);
  };
  var handleOnKeyDownListItem = function handleOnKeyDownListItem(e) {
    e.stopPropagation();
    onKeyDown(e, item);
  };
  var content = jsx(React__default.Fragment, null, icon, jsx(Text, {
    fontSize: textSize,
    title: typeof label === "string" ? label : ""
  }, label));
  var tooltipElement = jsx(Tooltip, {
    key: "".concat(index, "-").concat(value),
    disabled: !tooltipContent,
    content: tooltipContent,
    parentProps: {
      className: "tooltip-content-wrapper"
    }
  }, content);
  return jsx("li", {
    className: dropdownItemClasses(value, className),
    tabIndex: 0,
    "data-testid": id,
    css: function css(theme) {
      return DropdownListItemStyles(theme, {
        isSearchable: isSearchable,
        level: level,
        isDisabled: isDisabled
      });
    },
    onClick: handleOnClickListItem,
    onKeyDown: handleOnKeyDownListItem
  }, tooltipElement);
};

export { DropdownListItem as default };
//# sourceMappingURL=DropdownListItem.js.map
